import React from 'react';
import { FieldArray, FormikProps } from 'formik';
import { FormControl, FormControlLabel, FormGroup, Checkbox, FormLabel } from '@mui/material';
import { styled } from '@mui/system';

interface CheckboxGroupProps {
  formik: FormikProps<any>;
}

const daysOfWeek = [
  { label: 'Pazartesi', value: 'pazartesi' },
  { label: 'Salı', value: 'sali' },
  { label: 'Çarşamba', value: 'carsamba' },
  { label: 'Perşembe', value: 'persembe' },
  { label: 'Cuma', value: 'cuma' },
];

const ResponsiveFormGroup = styled(FormGroup)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'wrap',
  gap: '16px',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

const CheckboxGroup: React.FC<CheckboxGroupProps> = ({ formik }) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = event.target;
    formik.setFieldValue(name, checked ? 1 : 0);
    formik.setFieldTouched('days', true); // 'days' alanını dokunulmuş olarak işaretliyoruz
  };

  const hasError = formik.errors.days && formik.touched.days;

  return (
    <FormControl component="fieldset" error={Boolean(hasError)}>
      <FormLabel component="legend" className='mt-3' style={{ color: hasError ? 'red' : 'inherit' }}>
        Çalışmak istediğiniz staj günlerini seçiniz. En az bir tane seçim yapmanız gerekmektedir!<span style={{ color: "red" }}> *</span>
      </FormLabel>
      <ResponsiveFormGroup>
        <FieldArray
          name="days"
          render={() => (
            daysOfWeek.map((day) => (
              <FormControlLabel
                key={day.value}
                control={
                  <Checkbox
                    checked={formik.values[day.value] === 1}
                    onChange={handleChange}
                    name={day.value}
                    color="primary"
                  />
                }
                label={day.label}
              />
            ))
          )}
        />
      </ResponsiveFormGroup>
      {<div style={{ color: 'red' }}>{formik.errors.days?.toString()}</div>}
    </FormControl>
  );
};

export default CheckboxGroup;
